<template>
  <div>
    Form Question Editor

    <div class="text-center">
      <v-dialog v-model="dialog" width="500">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="blue lighten-2" dark v-bind="attrs" v-on="on">
            Associate Question
          </v-btn>
        </template>

        <v-card>
          <v-card-title class="headline grey lighten-2">
            Associate Question
          </v-card-title>

          <v-col>
            <v-row>
              Form Data to Associate Question Text:
              <v-text-field></v-text-field> <v-icon>mdi-magnify</v-icon></v-row
            >
            <v-row> Question Text: <v-text-field></v-text-field> </v-row>
          </v-col>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog = false">
              submit
            </v-btn>
            <v-btn color="primary" text @click="dialog = false">cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div>
        <h1>All questions</h1>
        <div v-for="question in this.allQuestions" :key="question._id">
          <div style="border: 2px solid">
            <v-col
              ><v-row
                ><h3>{{ question.name }}</h3>
                <v-spacer></v-spacer>
                Associated with:
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" width="500">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      text
                      color="blue lighten-2"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="primary">mdi-pencil</v-icon>
                    </v-btn>
                  </template>

                  <v-card>
                    <v-card-title class="headline grey lighten-2">
                      Associate Question
                    </v-card-title>

                    <v-col>
                      <v-row>
                        Form Data to Associate Question Text:
                        <v-text-field></v-text-field>
                        <v-icon>mdi-magnify</v-icon></v-row
                      >
                      <v-row>
                        Question Text: <v-text-field></v-text-field>
                      </v-row>
                    </v-col>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="dialog = false">
                        submit
                      </v-btn>
                      <v-btn color="primary" text @click="dialog = false"
                        >cancel</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-btn color="primary" text><v-icon>mdi-delete</v-icon></v-btn>
              </v-row></v-col
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      allQuestions: {}
    };
  },
  created() {
    fetch("http://localhost:8000/glossary/api/glossary/fetch_questions")
      .then(res => res.json())
      .then(data => (this.allQuestions = data));
  }
};
</script>

<style></style>
